export default __webpack_public_path__ + "static/media/motorcycle_filled.e5707b26.svg";